import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDetalhesMetasEducacaoOrgao = '/service/contabilidade/transparencia/metaEducacao/'

class DetalhesMetasEducacaoOrgaoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia ? filtro.sequencia : '',
            mesLiquidacao: filtro.mesLiquidacao ? filtro.mesLiquidacao : '',
            exercicio: filtro.exercicio ? filtro.exercicio : '',
        }
        return this.conex.post(urlDetalhesMetasEducacaoOrgao + 'consultaMetasEducacaoOrgao/', JSON.stringify(data))
    }
}

export default DetalhesMetasEducacaoOrgaoService
